EmployerPaySheetService.$inject = ['$stateParams', 'hUser', 'userPermissions'];
function EmployerPaySheetService($stateParams, hUser, userPermissions) {
    const self = this;

    self.getPayDataSheetTypesWithAccess = async (brand) => {
        try {
            const [paySheetTypesRes, policyParser] = await Promise.all([
                PerformanceAggregatorAPI.getPaysheetTypes(brand.id, true),
                userPermissions.getBrandPolicy(brand.id)
            ]);

            const payDataSheets = paySheetTypesRes.paysheet_types;
            const paySheetTypes = [];

            if (brand.paysheet_payroll_type === 'DATA_PASS') {
                return [...payDataSheets];
            }

            for (const payDataSheet of payDataSheets) {
                const viewWagesPermissions = [];
                const brandPaysheetTypes = payDataSheet.brand_paysheet_types;

                for (const brandPaysheetType of brandPaysheetTypes) {
                    switch (brandPaysheetType.paysheet_type) {
                        case 'WEIGHTED_SHIFT':
                            viewWagesPermissions.push(userPermissions.PERMISSIONS.VIEW_WEIGHTED_SHIFT_EMPLOYEES_WAGES);
                            break;
                        case 'HOURLY':
                            viewWagesPermissions.push(userPermissions.PERMISSIONS.VIEW_HOURLY_EMPLOYEES_WAGES);
                            break;
                        case 'SALARIED':
                            viewWagesPermissions.push(userPermissions.PERMISSIONS.VIEW_SALARIED_EMPLOYEES_WAGES);
                            break;
                    }
                }

                if (policyParser.categories(policyParser.ALL).hasAll(viewWagesPermissions)) {
                    paySheetTypes.push(payDataSheet);
                }
            }

            return paySheetTypes;
        } catch (err) {
            console.error(err);
            throw err;
        }
    };

    self.canShowPayDataSheetTab = async (activeBrand) => {
        try {
            const payDataSheetTypesWithAccess = await self.getPayDataSheetTypesWithAccess(activeBrand);
            return payDataSheetTypesWithAccess.length > 0;
        } catch (err) {
            console.error(err);
            throw err;
        }
    };
}

angular
    .module("harriApp")
    .service("employerPaySheetService", EmployerPaySheetService);